'use client';
import { Picture } from '@/app/common';
import { Thumbnail as ThumbnailType } from '@workspace/interfaces';

interface ThumbnailProps {
  thumbnail: ThumbnailType;
  onPlay: () => void;
  className?: string;
  width?: number;
}

export function Thumbnail({
  thumbnail,
  onPlay,
  className = 'absolute inset-0 w-full h-full object-cover z-10',
  width = 1920,
}: ThumbnailProps) {
  if (!thumbnail?.url) return null;

  return (
    <div className="absolute inset-0 cursor-pointer" onClick={onPlay}>
      <Picture
        fill
        image={thumbnail}
        alt={thumbnail.bynderImage?.alt || thumbnail.alt || 'Media Thumbnail'}
        desktopWidth={width}
        desktopHeight={Math.round((width * 9) / 16)}
        mobileWidth={390}
        mobileHeight={219}
        imgClassName={className}
      />
    </div>
  );
}
